import { render, staticRenderFns } from "./atour.vue?vue&type=template&id=5feb72f0&scoped=true&"
import script from "./atour.vue?vue&type=script&lang=js&"
export * from "./atour.vue?vue&type=script&lang=js&"
import style0 from "./atour.vue?vue&type=style&index=0&id=5feb72f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb72f0",
  null
  
)

export default component.exports